import React from 'react';
import SectionProcessBg from './SectionProcessBg';

export default function PageHero({ kicker, title, subtitle, variant = 'compound', theme }) {
  return (
    <header className="page-hero sec-process-wrap" data-section-theme={theme || undefined}>
      <SectionProcessBg variant={variant} seed={2} />
      <div className="sec-process-content page-hero__inner">
        {kicker && <div className="page-hero__kicker">{kicker}</div>}
        <h1 className="page-hero__title">{title}</h1>
        {subtitle && <p className="page-hero__sub">{subtitle}</p>}
      </div>
    </header>
  );
}
